import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./MainScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.OrganizeDesk;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "OrganizeDesk.Phaser.IntroductionScene.1",
            "OrganizeDesk.Phaser.IntroductionScene.2",
            "OrganizeDesk.Phaser.IntroductionScene.3",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/OrganizeDeskGame/scenes/GameIntro.ts